import gql from "graphql-tag";

export default gql`

  query segmentationCount($input: SegmentationCountInput!) {
    count: segmentationCount(input: $input)
  }

`